export const QA_NAME_AUTH_ABOUT_MANUFACTURER_EMAIL_LINK =
  'authAboutManufacturerEmailLink'
